/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choose/view.blocks to change it.
import ChooseImageAction from './ChooseImageAction/index'
import React from 'react'
import SwitchImagesAction from './SwitchImagesAction/index'



/** @type {import('Simple/types.js').View} */
export default function Choose({
  children,
  viewPath = "/DesignSystem/ImageComparison/Content/Actions/Choose"
  
}) {
  return (<React.Fragment
>
<SwitchImagesAction
  viewPath={`${viewPath}/SwitchImagesAction`}
/>
<ChooseImageAction
  viewPath={`${viewPath}/ChooseImageAction`}
/>
{children}
</React.Fragment>)
}